import { render, staticRenderFns } from "./NumberingSelector.yaml?vue&type=template&id=8a4d10da&component"
import script from "./NumberingSelector.yaml?vue&type=script&lang=ts&component"
export * from "./NumberingSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports